import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import JobsSearch from '../../components/jobs/JobsSearch'
import PageHeader from '../../components/pageHeader/PageHeader'
import JobsContext from '../../contexts/JobsContext'
import JobsListHead from '../../components/heads/JobsListHead'
import { GetServerSideProps } from 'next'
import { getSEOData } from '../../lib/Utils'
import { SEOData } from '../../types/Common'

export default function JobsSearchPage({ currentUrl, domain }: SEOData) {
  const router = useRouter()
  const [s3FileName, setS3FileName] = useState('')
  const { query, isReady } = router
  const [holdHero, setHoldHero] = useState(true)

  const { setStateName } = useContext(JobsContext)

  useEffect(() => {
    const statePart = query.state ? query.state[0] : ''
    if (isReady) {
      setS3FileName(statePart)

      setStateName(statePart)

      setHoldHero(false)
    }
  }, [query, isReady, setStateName])

  return (
    <>
      <JobsListHead domain={domain} currentUrl={currentUrl} />
      <PageHeader
        bucket="truck-driving-jobs/hero"
        s3FileName={s3FileName}
        isHold={holdHero}
      />

      {!holdHero && <JobsSearch />}
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  return getSEOData(req)
}
